import { getCards, addCard, setDefaultCard, removeCard } from "@/api/card";

function getCardStatus(card) {
  let m = Number(card.expMonth);
  let y = Number(card.expYear);
  let nowY = new Date().getFullYear();
  let nowM = new Date().getMonth() + 1;
  if (y > nowY || (y === nowY && m > nowM + 1)) {
    return 'Valid'
  } else if (y === nowY && (m === nowM || m === nowM + 1)) {
    return 'Expires Soon'
  } else {
    return 'Invalid'
  }
}
function getCardColor(cardStatus) {
  if (cardStatus === 'Valid') {
    return '#069A49'
  } else if (cardStatus === 'Expires Soon') {
    return '#ef8600'
  } else {
    return '#cf1322'
  }
}


function mapCardsData(data) {
  const res = [];
  for (const item of data["cards"]) {
    let cardStatus = getCardStatus(item)
    res.push({
      id: item["id"],
      number: item["last4"],
      expire: `${String(item["expMonth"]).padStart(2, "0")}/${String(
        item["expYear"]
      ).slice(-2)}`,
      expMonth: String(item["expMonth"]).padStart(2, "0"),
      expYear: item.expYear,
      address: item["addressLine1"] || "no address",
      country: item["addressCountry"],
      state: item["addressState"],
      city: item["addressCity"],
      cardType: item["brand"],
      securityCode: String(item["dynamicLast4"]),
      isDefault: item["id"] === data["default"],
      postCode: item["addressZip"],
      cardStatus: cardStatus,
      cardColor: getCardColor(cardStatus),
      // https://stripe.com/docs/api/cards/object#card_object-brand
      logo: {
        "American Express": require("@/assets/img/card/logo/american-express@2x.png"),
        "Diners Club": require("@/assets/img/card/logo/diners-club@2x.png"),
        Discover: require("@/assets/img/card/logo/discover@2x.png"),
        JCB: require("@/assets/img/card/logo/jcb@2x.png"),
        MasterCard: require("@/assets/img/card/logo/master-card@2x.png"),
        UnionPay: require("@/assets/img/card/logo/unionpay@2x.png"),
        Visa: require("@/assets/img/card/logo/visa@2x.png")
      }[item["brand"]]
    });
  }
  return res;
}

export default {
  namespaced: true,
  state: () => ({
    cards: undefined
  }),
  mutations: {
    SET_CARDS(state, cards) {
      state.cards = cards;
    }
  },
  actions: {
    _getCards({ commit }) {
      return getCards().then(({ res }) => {
        commit("SET_CARDS", mapCardsData(res.data.data));
      });
    },
    async getCards({ state, dispatch }) {
      if (state.cards === undefined) {
        await dispatch("_getCards");
      }
      return state.cards;
    },
    addCard({ dispatch }, data) {
      return addCard(data).then(({ res }) => {
        if (res.data.message && res.data.message.includes('bind card error')) {
          throw res.data.message
        } else {
          return dispatch("_getCards");
        }
      });
    },
    setDefaultCard({ dispatch }, { cardId }) {
      return setDefaultCard(cardId).then(() => {
        return dispatch("_getCards");
      });
    },
    removeCard({ dispatch }, { cardId }) {
      return removeCard(cardId).then(() => {
        return dispatch("_getCards");
      });
    }
  }
};
